export type SupportDocSection = {
  heading: string;
  orderedItems?: string[];
  bullets?: string[];
};

export type SupportDoc = {
  id: string;
  title: string;
  sections: SupportDocSection[];
};

export const supportDocs: SupportDoc[] = [
  {
    id: 'bland-organization',
    title: 'How To Organize Populate Bland Workspace',
    sections: [
      {
        heading: 'Phone Number Labels',
        orderedItems: [
          'Follow the below naming convention - [Practice] - [Pathway / Function]. Note: Some numbers can be used for multiple pathways (i.e. inbound and outbound both), please use function name in those cases. (i.e. Appointment Confirmation & Intake, CCM etc.)',
          'For Modmed practices please include (M) after the name. i.e. Athens Spine (M) - Appointment Confirmation',
          'For Demo numbers use the following format: [Practice Name] - Demo; [Practice Name] (M) - Demo',
          'For Populate numbers use the following format - Populate - Box Marketing; Populate - Doximity',
        ],
      },
      {
        heading: 'Folders And Their Purpose',
        bullets: [
          'Web Widgets -> Only contains Web Widget pathways',
          'Practice -> Any pathway created for practice, experimentation, learning',
          'Archived -> Bland pathways cannot be deleted by anyone other than admins. If a pathway is not used anymore, it should be in this folder.',
          'SMS Pathways -> Any pathway only used for SMS',
          'Prospect Demos -> Demo pathways created for any Practice',
          'WebDemos -> Populate demo pathways used in the Landing Pages',
          'PopulateEMR -> Production Pathways',
        ],
      },
    ],
  },
];
